import { init, tanstackRouterBrowserTracingIntegration } from '@sentry/react';

import { router } from '@/App';

init({
  dsn: 'https://1f88fd2c0da94a4cb4056b9497e5b84c@sentry.trafficon.eu/17',
  enabled: import.meta.env.MODE !== 'development',
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  integrations: [tanstackRouterBrowserTracingIntegration(router)],
  tracesSampleRate: import.meta.env.MODE === 'development' ? 1.0 : 0.1,
});
